import keyMirror from 'keymirror';

const EntityStateConstants = keyMirror({
  CREATING: null,
  DELETING: null,
  SAVED: null,
  UPDATING: null,
  UPDATING_ERROR: null,
});

export default EntityStateConstants;
